import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { buildReferencingBooks, hasCitation } from '@/utils/citationUtils';
import { useCitation } from '@/utils/citationPanelUtils';
import CitationPanelBookItem from '@/components/citation-panel-book-item.vue';
import { useRepositories } from '@/plugins/repositories';
export default defineComponent({
  name: 'CitationPanelBook',
  components: {
    CitationPanelBookItem: CitationPanelBookItem
  },
  props: {
    documentId: {
      type: String,
      required: false,
      default: undefined
    },
    sectionKeys: {
      type: Array,
      required: false,
      default: undefined
    },
    selected: {
      type: Boolean,
      required: true
    },
    hasKommentar: {
      type: Boolean,
      required: true
    }
  },
  setup: function setup(props, context) {
    var repositories = useRepositories();
    var reference = computed(function () {
      return {
        documentId: props.documentId,
        sectionKeys: props.sectionKeys
      };
    });
    var loadingFlag = ref({
      books: false,
      kommentarBooks: false
    });
    var loadStart = function loadStart(key) {
      loadingFlag.value = _objectSpread(_objectSpread({}, loadingFlag.value), {}, _defineProperty({}, key, true));
      context.emit('update:loading', true);
    };
    var loadEnd = function loadEnd(key) {
      loadingFlag.value = _objectSpread(_objectSpread({}, loadingFlag.value), {}, _defineProperty({}, key, false));
      if (Object.values(loadingFlag.value).every(function (flag) {
        return !flag;
      })) {
        context.emit('update:loading', false);
      }
    };
    var _useCitation = useCitation(reference, {
        fetcher: function () {
          var _fetcher = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(documentId, sectionKeys) {
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  _context.t0 = buildReferencingBooks;
                  _context.next = 3;
                  return repositories.citations.getCitationBook(documentId, sectionKeys);
                case 3:
                  _context.t1 = _context.sent;
                  return _context.abrupt("return", (0, _context.t0)(_context.t1));
                case 5:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          function fetcher(_x, _x2) {
            return _fetcher.apply(this, arguments);
          }
          return fetcher;
        }(),
        prevent: computed(function () {
          return !props.selected;
        }),
        beforeFetch: function beforeFetch() {
          return loadStart('books');
        },
        afterFetch: function afterFetch() {
          return loadEnd('books');
        }
      }),
      books = _useCitation.list;
    var _useCitation2 = useCitation(reference, {
        fetcher: function () {
          var _fetcher2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(documentId, sectionKeys) {
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.t0 = buildReferencingBooks;
                  if (!props.hasKommentar) {
                    _context2.next = 7;
                    break;
                  }
                  _context2.next = 4;
                  return repositories.kommentar.getLawKommentars(documentId, sectionKeys);
                case 4:
                  _context2.t1 = _context2.sent;
                  _context2.next = 8;
                  break;
                case 7:
                  _context2.t1 = [];
                case 8:
                  _context2.t2 = _context2.t1;
                  return _context2.abrupt("return", (0, _context2.t0)(_context2.t2));
                case 10:
                case "end":
                  return _context2.stop();
              }
            }, _callee2);
          }));
          function fetcher(_x3, _x4) {
            return _fetcher2.apply(this, arguments);
          }
          return fetcher;
        }(),
        prevent: computed(function () {
          return !props.selected;
        }),
        beforeFetch: function beforeFetch() {
          return loadStart('kommentarBooks');
        },
        afterFetch: function afterFetch() {
          return loadEnd('kommentarBooks');
        }
      }),
      kommentarBooks = _useCitation2.list;
    return {
      books: books,
      kommentarBooks: kommentarBooks
    };
  },
  methods: {
    hasCitation: hasCitation
  }
});